export const selectAllStayReasons = state => state.stayReasons.data;
